import FORM_KEYS from 'apps/web/constants/forms/quizmaker/formKeys';
import { Portal } from 'apps/web/enums/portal.enum';
import * as yup from 'yup';

import * as fields from './fields';

const QuizMakerSchema = (portal: Portal) => {
  const isLocal = portal === Portal.PHILIPPINES;
  const isUSA = portal === Portal.USA;

  const localFields = {
    [FORM_KEYS.subject]: fields.subject,
    [FORM_KEYS.gradeLevel]: fields.gradeLevel,
    [FORM_KEYS.language]: fields.language,
    [FORM_KEYS.topic]: fields.topic,
    [FORM_KEYS.assessmentType]: fields.assessmentType,
  };
  const defaultFields = {
    [FORM_KEYS.subject]: fields.subject,
    [FORM_KEYS.gradeLevel]: fields.gradeLevel,
    [FORM_KEYS.language]: fields.language,
    [FORM_KEYS.time]: fields.time,
    [FORM_KEYS.difficulty]: fields.difficulty,
    [FORM_KEYS.number]: fields.number,
    [FORM_KEYS.topic]: fields.topic,
    [FORM_KEYS.assessmentType]: fields.assessmentType,
  };
  const americaFields = {
    [FORM_KEYS.curriculumFramework]: fields.curriculumFramework,
    [FORM_KEYS.gradeLevel]: fields.gradeLevel,
    [FORM_KEYS.subject]: fields.subject,
    [FORM_KEYS.specificStandards]: fields.specificStandards,
    [FORM_KEYS.objective]: fields.textArea,
    [FORM_KEYS.objective2]: fields.optionalTextArea,
    [FORM_KEYS.objective3]: fields.optionalTextArea,
    [FORM_KEYS.strategies]: fields.strategies,
    [FORM_KEYS.language]: fields.language,
  };

  if (isLocal) {
    return yup.object().shape(localFields);
  }

  if (isUSA) {
    return yup.object().shape(americaFields);
  }

  return yup.object().shape(defaultFields);
};

export default QuizMakerSchema;
